import type { LanguageContextType } from "~/context/LanguageContext";

export type LanguageOption = {
  code: LanguageContextType["lang"];
  label: string;
  flag: string;
  /** Endonym: the language's name in itself, which is what a switcher should show. */
  name: string;
};

export const LANGUAGES: LanguageOption[] = [
  { code: "en", label: "EN", flag: "🇬🇧", name: "English" },
  { code: "fr", label: "FR", flag: "🇫🇷", name: "Français" },
  { code: "de", label: "DE", flag: "🇩🇪", name: "Deutsch" },
  { code: "ar", label: "AR", flag: "🇸🇦", name: "العربية" },
];
